import { TextContent, Text, Divider } from "@patternfly/react-core";
import { useTranslation } from "react-i18next";
import { LicenseStatus } from "../../store/license/license-status";
import { ModelType } from "../../store/global-types/customization-types";
import CurrentLicense from "../license/CurrentLicense";

interface LicenseProps {
    modelType?: ModelType;
    licenseStatus: LicenseStatus[];
}

const LicenseView = (props: LicenseProps) => {
    const { licenseStatus, modelType } = props;

    const { t } = useTranslation();

    if (licenseStatus.length === 0) {
        return (
            <TextContent>
                <Text component="p">{t("licensePage.noLicense", { modelType: modelType || "" })}</Text>
            </TextContent>
        );
    }

    return (
        <>
            {
                licenseStatus.map((license, licenseIndex, licensesArray) => (
                        <div className="license-block" key={license.id} data-testid="license-block">
                            <CurrentLicense licenseStatus={license} />
                            {licenseIndex !== licensesArray.length - 1 && <Divider className="content-divider" />}
                        </div>
                    )
                )
            }
        </>
    );
};

export default LicenseView;
